// SEO-текст market-страницы: секции с настоящими <h2>/<h3>, списками и
// таблицами. Данные — в `mode.seoContent`, форма записи:
//
//   seoContent: [
//     {
//       id: 'scenario',                       // якорь, необязателен
//       title: 'Что делают тестировщики',     // <h2>
//       blocks: [ { type: 'p', text: '…' }, … ] // см. SeoContentBlocks.jsx
//     },
//     …
//   ]
//
// Верстка намеренно повторяет ArticlePreview (заголовок над карточкой Plate):
// новых визуальных сущностей на странице не появляется.
//
// Важно: ничего не прячется под спойлеры, вкладки и «показать ещё» — весь текст
// присутствует в DOM сразу. Скрытый текст Яндекс считает признаком
// переоптимизации, а SSR (boostclick-ssr) снимает страницу без кликов.

import Plate from "components/UI/Plate/Plate";

import SeoContentBlock from "./SeoContentBlocks";

import "./SeoContent.scss";

export default function SeoContent({ sections }) {
  if (!Array.isArray(sections) || !sections.length) return null;

  return (
    <div className="seo-content">
      {sections.map((section, i) => (
        <section
          key={i}
          id={section.id}
          className="seo-content__section"
        >
          <h2 className="seo-content__title">{section.title}</h2>
          <Plate className="seo-content__plate">
            {section.blocks?.map((block, j) => (
              <SeoContentBlock key={j} block={block} />
            ))}
          </Plate>
        </section>
      ))}
    </div>
  );
}
